var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-card"},[_vm._t("icon"),_c('h3',[_vm._v(_vm._s(_vm.header))]),_c('p',[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }